import * as Types from '../../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type CompleteOnboardingStepMutationVariables = Types.Exact<{
  input: Types.CompleteOnboardingStepInput
}>

export type CompleteOnboardingStepMutation = {
  __typename?: 'Mutation'
  completeOnboardingStep?: {
    __typename?: 'CompleteOnboardingStepPayload'
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const CompleteOnboardingStepDocument = `
    mutation CompleteOnboardingStep($input: CompleteOnboardingStepInput!) {
  completeOnboardingStep(input: $input) {
    inputErrors {
      argument
      message
    }
  }
}
    `
export const useCompleteOnboardingStepMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<
    CompleteOnboardingStepMutation,
    TError,
    CompleteOnboardingStepMutationVariables,
    TContext
  >
) =>
  useMutation<CompleteOnboardingStepMutation, TError, CompleteOnboardingStepMutationVariables, TContext>(
    ['CompleteOnboardingStep'],
    (variables?: CompleteOnboardingStepMutationVariables) =>
      fetchGql<CompleteOnboardingStepMutation, CompleteOnboardingStepMutationVariables>(
        CompleteOnboardingStepDocument,
        variables
      )(),
    options
  )
